import React from 'react';

import { Svg, SvgProps } from '@lglp/components';

import styles from './ArrowKeyFigureUser.module.scss';

const ArrowKeyFigureUser: React.FC<ArrowKeyFigureUserProps> = ({
  className,
  ...rest
}) => {
  return (
    <Svg
      className={[styles.arrow, className]}
      viewBox="0 0 113.002 117"
      {...rest}
    >
      <g id="Groupe_1305">
        <path
          id="Tracé_1414"
          d="M255.33 83.814a2.687 2.687 0 0 0-3.595-1.245l-11.212 5.449a50.415 50.415 0 1 0-57.229 32.162 2.692 2.692 0 0 0 1.051-5.281 45.188 45.188 0 0 1-6.856-86.686A45.146 45.146 0 0 1 235.275 86.7L229.7 74.735a2.691 2.691 0 1 0-4.879 2.275l8.2 17.6a2.685 2.685 0 0 0 3.614 1.285l17.452-8.484a2.694 2.694 0 0 0 1.243-3.597z"
          className={styles.cls1}
          transform="translate(-142.601 -20)"
        />
        <circle
          id="Ellipse_51"
          cx="2.692"
          cy="2.692"
          r="2.692"
          className={styles.cls1}
          transform="translate(51.45 95.615)"
        />
        <circle
          id="Ellipse_52"
          cx="2.692"
          cy="2.692"
          r="2.692"
          className={styles.cls1}
          transform="translate(79.919 83.34)"
        />
        <circle
          id="Ellipse_53"
          cx="2.692"
          cy="2.692"
          r="2.692"
          className={styles.cls1}
          transform="translate(67.05 91.609)"
        />
      </g>
      <g id="Groupe_1306" transform="translate(4 4)">
        <path
          id="Tracé_1405"
          d="M175.66 54.018c-6.627 0-12 5.186-12 11.406 0 4.319 1.331 3.539 12 3.539s12-.035 12-3.539c0-6.278-5.373-11.406-12-11.406z"
          className={styles.cls2}
          transform="translate(-129.66 29.982)"
        />
        <circle
          id="Ellipse_49"
          cx="7"
          cy="7"
          r="7"
          className={styles.cls2}
          transform="translate(39 68)"
        />
      </g>
      <ellipse
        id="Ellipse_5"
        cx="25.025"
        cy="2.807"
        fill="#efefef"
        rx="25.025"
        ry="2.807"
        transform="translate(30.483 111.385)"
      />
    </Svg>
  );
};

type ArrowKeyFigureUserProps = SvgProps;

export default ArrowKeyFigureUser;
